module.exports = __webpack_public_path__ + "static/img/youxuan.ff5c0dbc.png";